import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicLineTypeDto extends EpimsBaseEntityDto {
  LineNumberName: string;
  LineNumber: number;
  SubscriberEmail: string;
  SubscriptionUserId: string;
  Version: number;
}
